export enum ESelectedActionTypes {
  CLOSE_ACCOUNT_POPUP = 'closeAccountPopUp'
}
